import { render, staticRenderFns } from "./commdityRight.vue?vue&type=template&id=574f485e&scoped=true&"
import script from "./commdityRight.vue?vue&type=script&lang=js&"
export * from "./commdityRight.vue?vue&type=script&lang=js&"
import style0 from "./commdityRight.vue?vue&type=style&index=0&id=574f485e&lang=scss&scoped=true&"
import style1 from "./commdityRight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f485e",
  null
  
)

export default component.exports